import { createRootRoute, Link } from '@tanstack/react-router';
import type { JSX } from 'react';

import { CtLogo } from '@/components/brand/CtLogo.js';

import { AppShell } from '../AppShell.js';

export const Route = createRootRoute({
  component: AppShell,
  notFoundComponent: NotFound,
});

function NotFound(): JSX.Element {
  return (
    <div className="flex h-full flex-col items-center justify-center px-6 py-20">
      <div className="flex max-w-sm flex-col items-center gap-10 text-center">
        <div className="flex items-center gap-3">
          <CtLogo
            variant="mark"
            tone="mono"
            className="size-10 text-[#18399b] [[data-theme='dark']_&]:text-white"
          />
          <span className="font-heading text-2xl font-extrabold leading-[1.1] tracking-[-0.025em] text-foreground">
            Agent
          </span>
        </div>

        <div className="flex flex-col gap-2">
          <h1 className="font-heading text-5xl font-extrabold tracking-tight text-foreground">
            404
          </h1>
          <p className="text-base text-muted-foreground">
            Page not found. The link may be broken or the page may have been
            removed.
          </p>
        </div>

        <Link
          to="/home"
          className="inline-flex h-10 items-center gap-2 rounded-full border border-primary/40 bg-transparent px-5 text-sm font-medium text-primary transition-all hover:border-primary hover:bg-primary hover:text-primary-foreground hover:shadow-lg active:scale-[0.98]"
        >
          Go to Home
        </Link>
      </div>
    </div>
  );
}
